module.exports = __webpack_public_path__ + "img/cloth_g3_hat-09.c22c983e.svg";